import React from 'react';
import SvgComponent from '../icons/SvgComponent';
import Introduction from '../text-Effects/Introduction';
import Button from '../button/Button';
import HireMeButton from '../button/HireMeButton';
import { motion } from 'framer-motion';

function MainHome() {
    return (
        <div className="min-h-screen flex items-center relative overflow-hidden">
            
            {/* Main Content Section */}
            <section className="w-full flex flex-col-reverse lg:flex-row lg:justify-between px-6 py-12 lg:px-16 lg:py-20">

                {/* Text Section */}
                <div className="w-full lg:w-1/2 flex flex-col justify-center items-center lg:items-start text-center lg:text-left space-y-8">
                    <Introduction />

                    <motion.div
                        className="mt-6 w-full flex justify-center lg:justify-start space-x-4"
                        whileInView={{ opacity: 1, y: 0 }}
                        whileOutView={{ opacity: 0, y: 100 }}
                        initial={{ opacity: 0, y: 100 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: false }}
                    >
                        <motion.a href="/kailash.pdf" target="_blank">
                            <Button
                                name="Resume"
                                className="px-6 py-3 lg:px-8 lg:py-4 bg-dark dark:bg-light text-light dark:text-dark border-2 border-light dark:border-dark hover:border-transparent hover:bg-gradient-to-r from-purple-400 to-blue-400 rounded-full shadow-lg hover:shadow-2xl transform hover:scale-105 transition-transform duration-300 ease-in-out"
                            />
                        </motion.a>
                        <motion.a href="#contact">
                            <Button
                                name="Contact"
                                className="px-6 py-3 lg:px-8 lg:py-4 bg-light dark:bg-dark text-dark dark:text-light border-2 border-dark dark:border-light hover:border-transparent hover:bg-gradient-to-r from-pink-400 to-red-400 rounded-full shadow-lg hover:shadow-2xl transform hover:scale-105 transition-transform duration-300 ease-in-out"
                            />
                        </motion.a>
                    </motion.div>
                </div>

                {/* SVG Section */}
                <div className="w-full lg:w-1/2 flex justify-center lg:justify-end items-center relative">
                    <motion.div
                        initial={{ opacity: 0, scale: 0 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.6 }}
                        className="relative rounded-full p-6 shadow-xl hover:shadow-2xl border-8 border-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 transform hover:scale-105 transition-transform duration-200 ease-in-out"
                    >
                        <SvgComponent className="w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 fill-current text-dark dark:text-light transition-transform transform hover:scale-110" />
                    </motion.div>
                    <div className="absolute bottom-4 lg:bottom-8">
                        <HireMeButton />
                    </div>
                </div>
            </section>

            {/* Decorative Border around the section */}
            <div className="absolute inset-0 pointer-events-none border-4 border-dotted border-light dark:border-dark rounded-xl opacity-20 transition-opacity hover:opacity-40"></div>
        </div>
    );
}

export default MainHome;
